import R from 'ramda';

export const validateFileUpload = ({ dissertationFileName }) =>
  R.isEmpty(dissertationFileName)
    ? { dissertationFile: ['Please select a file'] }
    : void 0;



// WEBPACK FOOTER //
// ./src/file-upload/fileUploadValidation.js